import { createContext, useContext } from 'react';

export interface SidebarContextValue {
  open: boolean;
  toggle: () => void;
  setOpen: (v: boolean) => void;
}

export const SidebarContext = createContext<SidebarContextValue>({
  open: false,
  toggle: () => {},
  setOpen: () => {},
});

export const useSidebar = () => useContext(SidebarContext);
